import ActivateReserves from "./ActivateReserves.view";

export default ActivateReserves;
